export default "__VITE_ASSET__wEblLPmn__"